import { getAccessToken } from '../selectors/token'
import store from '../store'

const getToken = () => {
  return getAccessToken(store.getState())
}

export default getToken
